import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LoginFieldsGeneralService } from '@app/services/login-fields/service/login-fields-general.service copy';
import { LoginFieldsPortalService } from '@app/services/login-fields/service/login-fields-portal.service';
import { LoaderService } from '../loader/loader.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogConfirmChangeGeneralSettingsComponent } from '../dialog/template/dialog-confirm-change-general-settings/dialog-confirm-change-general-settings.component';
import { MatDialog } from '@angular/material';
import { ConfirmComponent } from '../confirm/confirm.component';
import { convertToInt } from '@shared/utils/util';
@Component({
  selector: 'app-login-fields',
  templateUrl: './login-fields.component.html',
  styleUrls: ['./login-fields.component.scss']
})
export class LoginFieldsComponent implements OnInit {
  @Input()
  public integration: any;
  public data: any = false;
  public form: FormGroup;
  public cascade_change = false;
  public options = [
    { 'type': 'cpf', 'name': 'CPF' },
    { 'type': 'date', 'name': 'Data' },
    { 'type': 'number', 'name': 'Número' },
    { 'type': 'text', 'name': 'Texto' }
  ]
  public date: any;

  constructor(
    public formBuilder: FormBuilder,
    public loginFieldsGeneralService: LoginFieldsGeneralService,
    public loginFieldsPortalService: LoginFieldsPortalService,
    private router: ActivatedRoute,
    private loaderService: LoaderService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.createForm();
    if (this.integration == "general") {
      this.searchGeneral();
    }
    if (this.integration == "portal") {
      this.searchPortal();
    }
  }

  private searchGeneral() {
    this.loginFieldsGeneralService.readBasic().subscribe(
      success => this.success(success),
      error => this.error('Ocorreu um erro ao buscar os dados de login.')
    )
  }

  private setForm(data) {
    this.form.patchValue(data.date_changes);
    data.fields.forEach((value, index) => {
      const val = this.form.get(['fields', index]);
      val.patchValue({
        id: value.id,
        label: value.label,
        type: value.type,
      })
    });
  }

  private searchPortal() {
    this.loginFieldsPortalService.read(this.router.snapshot.params.id).subscribe(
      success => this.success(success),
      error => this.error('Ocorreu um erro ao buscar os dados de login.')
    )
  }

  private success(success) {
    if (success.success) {
      if (success.data && success.data.fields.length >= 1) {
        this.data = success.data.fields;
        this.setForm(success.data);
      }
    }
  }

  private error(message) {
    this.loaderService.setChangesLoaderState(false,
      message,
      'ok',
      'error'
    );
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      fields: this.formBuilder.array([this.createField(), this.createField()]),
      last_change: [null],
      changed_by: [null]
    });
  }

  createField(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      type: ['', Validators.required],
      label: ['', Validators.required]
    });
  }

  resetValidation() {
    this.data.forEach((value, index) => {
      const val = this.form.get(['fields', index]);
      val.patchValue({
        id: value.id,
        label: value.label,
        type: value.type,
      })
    });
  }

  onDialog() {
    if (this.integration == 'portal') {
      const state = this.data ? 'alterar' : 'salvar';
      this.dialog.open(ConfirmComponent, {
        maxWidth: '60vw',
        width: '355px',
        minHeight: '210px',
        autoFocus: false,
        data: {
          title: 'Atenção',
          message: `Deseja realmente ${state} as configurações de campos de login?`,
          btnOkText: 'Salvar',
          btnCancelText: 'Cancelar',
          reverseBtn: false
        },
        disableClose: false
      }).afterClosed().subscribe(success => {
        if (success) {
          this.submit(0);
        }
      });
    }

    if (this.integration == 'general') {
      const dialog = this.dialog.open(DialogComponent, {
        width: '754px',
        height: '373px',
        data: {
          titleDialog: 'Atenção',
          titleButton: 'Salvar',
          component: DialogConfirmChangeGeneralSettingsComponent,
          cascadeChanges: this.cascade_change,
          headerRed: true
        },
        autoFocus: false,
        disableClose: true
      });

      dialog.beforeClosed().subscribe(
        resp => {
          if (typeof resp === 'boolean') {
            if (resp) {
              dialog.afterClosed().subscribe(
                result => {
                  this.submit(convertToInt(result.data.cascade_change));
                }
              );
            }
          }
        }
      );
    }
  }

  submit(cascade_change) {
    const login_fields = this.form.getRawValue();
    if (this.integration == 'general') {
      login_fields.cascade_change = cascade_change
      this.submitedGeneral(login_fields)
    }

    if (this.integration == 'portal') {
      this.submitedPortal(login_fields)
    }

  }

  submitedGeneral(login_fields) {
    this.loginFieldsGeneralService.create(login_fields).subscribe(
      success => {
        if (!success.success) {
          return this.error("Ocorreu um erro ao salvar os dados de login.");
        }
        this.data = success.data.fields;
        this.setForm(success.data);
        this.loaderService.setChangesLoaderState(false,
          'Dados de login salvos com sucesso.',
          'ok',
          'success'
        );
      },
      error => this.error("Ocorreu um erro ao salvar os dados de login.")
    )
  }

  submitedPortal(login_fields) {
    login_fields.portal_id = this.router.snapshot.params.id;
    this.loginFieldsPortalService.create(login_fields).subscribe(
      success => {
        if (!success.success) {
          return this.error("Ocorreu um erro ao salvar os dados de login.");
        }
        this.data = success.data.fields;
        this.setForm(success.data);
        this.loaderService.setChangesLoaderState(false,
          'Dados de login salvos com sucesso.',
          'ok',
          'success'
        );
      },
      error => this.error("Ocorreu um erro ao salvar os dados de login.")
    )
  }

  get fields(): FormArray {
    return this.form.controls['fields'] as FormArray;
  }
}
